function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { Severity as r } from "@sentry/react";
var _e = function e() {
  return _e = Object.assign || function (r) {
    for (var e, n = 1, t = arguments.length; n < t; n++) for (var i in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    return r;
  }, _e.apply(this, arguments);
};
function n(r, e, n) {
  if (n || 2 === arguments.length) for (var t, i = 0, o = e.length; i < o; i++) !t && i in e || (t || (t = Array.prototype.slice.call(e, 0, i)), t[i] = e[i]);
  return r.concat(t || Array.prototype.slice.call(e));
}
function t(r) {
  if (!(r instanceof Error)) throw new Error("AssertionError: not an Error");
}
function i(r) {
  r.exception && r.exception.values && r.exception.values.forEach(function (r) {
    r.mechanism && (r.mechanism.handled = !0);
  });
}
function o(r) {
  var e = /Loading chunk (.+) failed\./i.exec(r);
  if (e && e[1]) return e[1];
}
var a = {
  debug: 0,
  log: 0,
  info: .1,
  warning: .5,
  error: 1,
  critical: 1,
  fatal: 1
};
function c() {
  return Math.random();
}
var l = [function (r, e) {
  try {
    var n = null == e ? void 0 : e.originalException;
    t(n);
    if (n.stack && [/analytics\.js/].some(function (r) {
      return r.test(n.stack);
    })) return null;
  } catch (r) {}
  return r;
}, function (e, n) {
  try {
    var t = null == n ? void 0 : n.originalException;
    return function (r) {
      if (!(r instanceof Error) || "ChunkLoadError" !== r.name) throw new Error("AssertionError: not a ChunkLoadError");
    }(t), e.level === r.Error && (e.level = r.Warning), e.fingerprint = [t.name, t.type, o(t.message) || t.message], i(e), e;
  } catch (r) {
    return e;
  }
}, function (r, e) {
  try {
    var n = null == e ? void 0 : e.originalException;
    return "string" == typeof n && /Failed to update event/.test(n) || n && "object" == _typeof(n) && /Failed to update event/.test(n.message) ? null : r;
  } catch (e) {
    return r;
  }
}, function (r, e) {
  try {
    var n = null == e ? void 0 : e.originalException;
    t(n), /FetchEvent\.respondWith received an error/.test(n.message) && (r.fingerprint = ["FetchEvent.respondWith received an error"]);
  } catch (r) {}
  return r;
}, function (r, e) {
  try {
    var n = null == e ? void 0 : e.originalException;
    t(n), "SecurityError" === n.name && /Blocked a frame with origin/.test(n.message) && (r.fingerprint = [n.name, "Blocked a frame with origin"]);
  } catch (r) {}
  return r;
}, function (r, e) {
  try {
    var n = null == e ? void 0 : e.originalException;
    t(n);
    if ([/mraidbridge/, /\(null\) is not a function\. \(In '\(null\)\(true, '(\w+)', '{"nonce":"(.+)"}'\)', '\(null\)' is null\)/, /a\[b\]\.target\.className\.indexOf is not a function/].some(function (r) {
      return r.test(n.message);
    })) return null;
    if (n.stack && [/SnapTube/].some(function (r) {
      return r.test(n.stack);
    })) return null;
  } catch (r) {}
  return r;
}, function (e) {
  try {
    var n = !1;
    return e.exception && e.exception.values && e.exception.values.forEach(function (r) {
      var e,
        t,
        i = null === (t = null === (e = r.stacktrace) || void 0 === e ? void 0 : e.frames) || void 0 === t ? void 0 : t[0];
      i && "?" === i.function && (/\/_next\/static\/chunks\/webpack/.test(i.filename) || /\/_next\/static\/chunks\/139/.test(i.filename)) && (n = !0);
    }), n && (e.level = r.Warning, e.message && /NetworkError/.test(e.message) && (e.fingerprint = ["NetworkError"]), i(e)), e;
  } catch (r) {
    return e;
  }
}, function (r, e) {
  try {
    var n = null == e ? void 0 : e.originalException;
    if (t(n), /Failed to register a ServiceWorker/.test(n.message)) {
      var i = ["AbortError", "InvalidStateError", "NotSupportedError", "SecurityError"].find(function (r) {
        return new RegExp(r).test(n.message);
      });
      r.fingerprint = ["Failed to register a ServiceWorker"], r.fingerprint.push(i || n.message);
    }
  } catch (r) {}
  return r;
}];
function u(r, e) {
  for (var n = 0, t = l; n < t.length; n++) {
    if (null === (0, t[n])(r, e)) return null;
  }
  return r.exception && r.exception.values && r.exception.values.forEach(function (e) {
    var n = e.mechanism && "instrument" === e.mechanism.type;
    ("fatal" === r.level || n) && e.mechanism && (e.mechanism.handled = !1);
  }), function (r, e) {
    return void 0 === e && (e = c), !!r.level && e() < a[r.level];
  }(r) ? r : null;
}
export { _e as _, n as a, u as b };